<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch110">
<p class="para2"><span class="bold">APRAKSIN, Stepan Stepanovich</span> (b. 24 June 1757, Riga – d. 20 February 1827, Moscow) was born to a prominent Russian family, the son of Field Marshal Stepan Fedorovich Apraksin. He was enlisted as ensign in the Life Guard Semeyonovsk Regiment upon his birth in 1757 and was promoted to captain in 1772. Apraksin later transferred as a colonel to the Kiev Infantry Regiment and was appointed a flügel adjutant in 1777. He took command of the Kiev Infantry Regiment in 1782 and participated in the operations against the Turks in the Crimea. In 1783, he became a brigadier and served with the Astrakhan Carabineer Regiment in the Caucasus and Kuban Valley, receiving the Order of St. Vladimir (3rd class). He was promoted to major general and appointed chef of the Astrakhan Carabineer Regiment on 23 February 1786.</p>
<p class="para">Apraksin took part in the Russo-Turkish War in 1787-1791, distinguishing himself at Ochakov. In 1793, he became a lieutenant general and served in Poland in 1794. He rose to a lieutenant general on 13 September 1794, to general of cavalry on 23 March 1798 and took command of the Astrakhan Dragoon Regiment on 14 December 1796. Apraksin retired because of poor health in December 1798 but returned to the army in 1801, serving as the head of the Moscow and Smolensk Inspections. In 1803, he became the Military Governor of Smolensk. Four years later, he organized the 16th Division and commanded it against the Turks in the Danubian Principalities in 1807-1808. He retired again in 1809 and settled in Moscow, where he died on 20 February 1827.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_ch110.vue?347cdeb2